
        Component.define('internal-car', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

$('.slider-galery').slick({
  dots: true,
  slidesPerRow: 5,
  rows: 2,
});

$('#compare-select').on('change', function(){
    const $this = $(this);
    $('.status .percentage').removeClass('active');

    $('.chart-items .item').each(function(){
        const $thisPer = $(this);
        const $percent = $thisPer.find('.status [data-category-id="' + $this.val() + '"]');
        $percent.addClass('active');

        setTimeout(function(){
            $thisPer.find('.status .percentage').width($percent.attr('data-percentual') + '%');
        }, 50);
    });
});

$('#compare-select').trigger('change');

        });